// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    background-color: #f9f9f9;
}

.login-form {
    background-color: #fff;
    padding: 1.5rem;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    width: 320px;
}

.login-form label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: bold;
    color: #333;
}

.login-form input[type="email"],
.login-form input[type="password"] {
    display: block;
    width: 92%;
    margin-bottom: 1rem;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.login-form button {
    width: 100%;
    padding: 0.75rem;
    background-color: #0078d4;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.logo-login {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 1rem;
    width: auto;
    height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB","sourcesContent":[".login-page {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    background-color: #f9f9f9;\n}\n\n.login-form {\n    background-color: #fff;\n    padding: 1.5rem;\n    border: 1px solid #eaeaea;\n    border-radius: 4px;\n    width: 320px;\n}\n\n.login-form label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: bold;\n    color: #333;\n}\n\n.login-form input[type=\"email\"],\n.login-form input[type=\"password\"] {\n    display: block;\n    width: 92%;\n    margin-bottom: 1rem;\n    padding: 0.75rem;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.login-form button {\n    width: 100%;\n    padding: 0.75rem;\n    background-color: #0078d4;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.logo-login {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto 1rem;\n    width: auto;\n    height: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
